import { useQuery } from 'react-query';

import { PaginatedList } from '../../../types/PaginatedList';
import { PostRequest } from '../../../types/PostRequest';
import Api from '../../api/api';

export type GetPostRequestDto = {
  page?: number;
  limit?: number;
  sort?: string;
  search?: string;
  type?: string;
};

const getAllPostRequests = async (params: GetPostRequestDto): Promise<PaginatedList<PostRequest>> => {
  const [response, bodyOrError] = await Api.get('posts/requests', params);

  if (!response?.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

const useGetAllPostRequests = (params: GetPostRequestDto) => {
  return useQuery({
    queryKey: ['getAllPostRequests', params],
    queryFn: () => getAllPostRequests(params),
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
};

export default useGetAllPostRequests;
